import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  allPosts: [],
  loading: false,
  error: false,
};

const getAllPostsRequest = createAction("getAllPostsRequest");
const getAllPostsSuccess = createAction("getAllPostsSuccess");
const getAllPostsFailure = createAction("getAllPostsFailure");

export const postsReducer = createReducer(initialState, (builder) => {
  builder
    // Get All Posts
    .addCase(getAllPostsRequest, (state) => {
      state.loading = true;
    })
    .addCase(getAllPostsSuccess, (state, action) => {
      state.loading = false;
      state.allPosts = action.payload;
    })
    .addCase(getAllPostsFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
